
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/blackbear",
      function () {
        return require("private-next-pages/brands/blackbear.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/blackbear"])
      });
    }
  